import * as EcSearchUtils from './utils/SearchUtils';
import ResHelper from "./utils/ResHelper";
import * as FormRules from "./utils/FormRules";
import * as CommonFn from "./utils/CommonFn";
import moment from "moment";
export default {
  install: (Vue) => {
    Vue.prototype.$EcSearchUtils = EcSearchUtils;
    //须定义为'$'+类名，在template中使用$ResHelper调用，在script中，通过this.$ResHelper调用
    Vue.prototype.$ResHelper = ResHelper;
    Vue.prototype.$FormRules = FormRules;
    Vue.prototype.$CommonFn = CommonFn;
    Vue.prototype.$moment = moment;
  }
}



// WEBPACK FOOTER //
// ./src/common/index.js